export const ADMIN_PENDING_SHADCHANIM_SUCCESS =
  "ADMIN_PENDING_SHADCHANIM_SUCCESS";
export const ADMIN_GET_USERS_SUCCESS = "ADMIN_GET_USERS_SUCCESS";
export const ADMIN_BLOCK_USER_SUCCESS = "ADMIN_BLOCK_USER_SUCCESS";
export const ADMIN_UNBLOCK_USER_SUCCESS = "ADMIN_UNBLOCK_USER_SUCCESS";
